import request from "@/utils/request";

//协会列表
export function listJoin(query) {
    return request({
        url: '/h5/join/list',
        method: 'get',
        params: query
    })
}

// 查询协会信息详情
export function getJoinById(id) {
    return request({
        url: '/h5/join/'+id,
        method: 'get',
    })
}

//我的协会列表
export function MelistJoin(query) {
    return request({
        url: '/h5/join/Melist',
        method: 'get',
        params: query
    })
}
